import { Component, OnInit } from '@angular/core';
import { ModalDirective, BsModalRef, BsModalService } from 'ngx-bootstrap/modal';

@Component({
  selector: 'app-fail-message',
  templateUrl: './fail-message.component.html',
  styleUrls: ['./fail-message.component.scss']
})
export class FailMessageComponent implements OnInit {

  constructor(private modalRef: BsModalRef) { }

  ngOnInit(): void {
  }

  public onCancel(): void { 
    this.modalRef.hide();
  }

}
